import { Component, input, output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { VcInput } from '../vc-input/vc-input';

/** Company name → sales url slug, as the old app did it: spaces to dashes, anything else non-ASCII-alphanumeric dropped. */
export function parseDomain(companyName: string): string {
  return companyName
    .trim()
    .replace(/\s+/g, '_dash_')
    .replace(/\W/g, '')
    .replace(/_dash_/g, '-')
    .replace(/-+$/, '')
    .toLowerCase();
}

/** The two fields; the domain follows the company name until the user edits the domain by hand. */
@Component({
  selector: 'app-company-domain-sync',
  imports: [VcInput, TranslatePipe],
  templateUrl: './company-domain-sync.html',
})
export class CompanyDomainSync {
  readonly companyName = input.required<FormControl<string>>();
  readonly domain = input.required<FormControl<string>>();
  readonly enter = output();

  private syncOn = true;
  private derived = '';

  onCompanyChange(value: string) {
    if (!this.syncOn) {
      return;
    }
    this.derived = parseDomain(value);
    if (value.length > 0) {
      this.applyDerived();
    }
  }

  onCompanyBlur() {
    if (this.syncOn) {
      this.applyDerived();
    }
  }

  onDomainChange(value: string) {
    if (value !== this.derived) {
      this.syncOn = false;
    }
  }

  private applyDerived() {
    const domain = this.domain();
    domain.setValue(this.derived);
    domain.markAsDirty();
    domain.markAsTouched();
  }
}
